import LoginForm  from '../components/Forms/LoginForm';

function LoginPage(){
    return <section style={{margin: "20px"}}>
        <h1>Login</h1>
        <LoginForm />
    </section>
}

export default LoginPage;